import taxStatus from '@/languages/ko-kr/tax-status'
import bankCodes from '@/languages/ko-kr/bank-codes'

export default {
  'keep-kr': '@:terms.keep-kr',
  'tax-bill': '@:terms.tax@:terms.bill',
  'payment': '@:terms.payment',
  'KRW': '@:terms.currency',
  'status': {
    ...taxStatus,
  },
  'confirm': {
    'ok': '예',
    'cancel': '아니오',
    'confirm-message': {
      'title': '이미 @:terms.payment한 @:terms.bill인가요?',
      'description': ['이 @:terms.bill를 @:terms.payment 완료 상태로 변경합니다.',
        '변경 후에는 "@:terms.payment내역" 화면에서 확인 가능합니다.'],
    },
    'success-message': {
      'title': '@:terms.payment 등록 완료!',
      'description': '세금! 이제는 쉽게 @:terms.keep하세요!',
    },
    'confirmed-tax': {
      'title': '담당 세무사가 있으신 경우',
      'description': '최종 신고 건인지 담당 세무사에게 확인 후 납부해주시기 바랍니다.',
    },
    'confirmed-expired': {
      'title': '@:terms.certificate가 만료되었습니다.',
      'description': '재등록 후 납부하실 수 있습니다.',
    },
  },
  'tax': {
    'epayNo': '전자@:terms.payment번호',
    'amount': '@:terms.payment @:terms.amount',
    'expDate': '@:terms.payment 기한',
    'account': '출금계좌',
    'paidDate': '@:terms.payment 일시',
    'addPay': '가산세',
    'currency': '@:terms.currency',
    'billOrgNm': '청구기관',
    'payerNm': '납세자명',
    'bizNo': '사업자등록번호',
    'taxNm': '세목',
    'payAmt1': '납기내금액',
    'payAmt2': '납기후금액',
    'payDate1': '납기내기한',
    'payDate2': '납기후기한',
    'taxYm': '과세대상',
    'tax1': '세액(본세)',
    'tax2': '세액(도시계획세)',
    'tax3': '세액(공동시설세등)',
    'tax4': '세액(지방교육세)',
    'taxSum': '세액 합계',
    'taxBase': '과세표준',
  },
  'message': {
    'empty': '@:terms.payment 내역이 없습니다.',
    'empty-gogi': '고지서가 존재하지 않습니다.',
  },
  'payment-register': '@:terms.payment하기',
  'bank-codes': {
    ...bankCodes,
  },
  'go-main': '홈으로',
  'error': {
    'get-tax': '고지서를 불러오는데 실패하였습니다.',
    'update-tax-status': '@:terms.tax @:terms.status를 @:terms.change하는데 실패하였습니다.',
  },
  'dialog': {
    'footer': {
      'confirm': '확인',
      'cancel': '취소',
      're-register': '재등록하기',
      'no': '아니요',
      'close': '닫기',
    },
  },
  'indefinite': '@:terms.indefinite',
  'title-invalid': '@:terms.payment 불가 @:terms.bill',
  'header': '@:terms.tax',
  'tax-bill-info': '@:terms.bill 정보'
}
